import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

export class OperationInventoryRequest {
    operation: OperationTypeEnum;
    plantId: number;
    batchNumbers?:[]

    /**
     * 
     * @param operation 
     * @param plantId 
     */
    constructor(operation: OperationTypeEnum, plantId: number,batchNumbers?:[]) {
        this.operation = operation;
        this.plantId   = plantId;
        this.batchNumbers = batchNumbers
    }
}